// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Existing styles for the header (keeping these intact) */
.header-container {
  background-color: white;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 2px -2px gray;
}

.logo-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.logo {
  width: 120px;  /* Adjust size if needed */
  height: auto;
}

.nav-links {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  list-style: none;
  margin-left: 20px;
  padding: 0;
  gap: 40px;
}

.nav-link {
  font-size: 18px;
  font-weight: bold;
  color: black;
  text-decoration: none;
  padding: 5px 10px;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #ff0000;
}

.login-button-container {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}

.login-button {
  background-color: #ffcc00;
  padding: 10px 25px;
  border-radius: 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-button:hover {
  background-color: #e6b800;
}

.logout-button {
  background-color: #ffcc00;
  padding: 10px 25px;
  border-radius: 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-button:hover {
  background-color: #e6b800;
}

/* Mobile View Styling */
@media (max-width: 768px) {
  .header-container {
      flex-direction: column;
      align-items: flex-start;
      position: relative; /* Ensure the login button is positioned within the header */
  }

  .logo {
      width: 100px;
  }

  .nav-links {
      display: none;
  }

  .hamburger-menu {
      display: block;
      font-size: 24px;
      cursor: pointer;
  }

  .nav-links.mobile-active {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      margin-top: 10px;
  }

  /* Position the login button in the top-right corner */
  .login-button-container {
      position: absolute;
      top: 10px;
      right: 10px;
  }

  .login-button {
      padding: 12px 24px;
      font-size: 16px;
  }
}

.nav-menu {
  display: none;
}
.nav-menu.open {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY,GAAG,0BAA0B;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE;MACI,sBAAsB;MACtB,uBAAuB;MACvB,kBAAkB,EAAE,4DAA4D;EACpF;;EAEA;MACI,YAAY;EAChB;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,cAAc;MACd,eAAe;MACf,eAAe;EACnB;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,WAAW;MACX,gBAAgB;EACpB;;EAEA,sDAAsD;EACtD;MACI,kBAAkB;MAClB,SAAS;MACT,WAAW;EACf;;EAEA;MACI,kBAAkB;MAClB,eAAe;EACnB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB","sourcesContent":["/* Existing styles for the header (keeping these intact) */\n.header-container {\n  background-color: white;\n  padding: 10px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 4px 2px -2px gray;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.logo {\n  width: 120px;  /* Adjust size if needed */\n  height: auto;\n}\n\n.nav-links {\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  list-style: none;\n  margin-left: 20px;\n  padding: 0;\n  gap: 40px;\n}\n\n.nav-link {\n  font-size: 18px;\n  font-weight: bold;\n  color: black;\n  text-decoration: none;\n  padding: 5px 10px;\n  transition: color 0.3s ease;\n}\n\n.nav-link:hover {\n  color: #ff0000;\n}\n\n.login-button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-left: auto;\n}\n\n.login-button {\n  background-color: #ffcc00;\n  padding: 10px 25px;\n  border-radius: 20px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.login-button:hover {\n  background-color: #e6b800;\n}\n\n.logout-button {\n  background-color: #ffcc00;\n  padding: 10px 25px;\n  border-radius: 20px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.logout-button:hover {\n  background-color: #e6b800;\n}\n\n/* Mobile View Styling */\n@media (max-width: 768px) {\n  .header-container {\n      flex-direction: column;\n      align-items: flex-start;\n      position: relative; /* Ensure the login button is positioned within the header */\n  }\n\n  .logo {\n      width: 100px;\n  }\n\n  .nav-links {\n      display: none;\n  }\n\n  .hamburger-menu {\n      display: block;\n      font-size: 24px;\n      cursor: pointer;\n  }\n\n  .nav-links.mobile-active {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      width: 100%;\n      margin-top: 10px;\n  }\n\n  /* Position the login button in the top-right corner */\n  .login-button-container {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n  }\n\n  .login-button {\n      padding: 12px 24px;\n      font-size: 16px;\n  }\n}\n\n.nav-menu {\n  display: none;\n}\n.nav-menu.open {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
